export default __webpack_public_path__ + "static/media/FEST_logo_det.06273f21.png";